import CheckinEntryAutoEntryCompleted from "../../../components/directivesFormSteps/CheckinEntryFormStep/AutoEntry/CheckinEntryAutoEntryCompleted";
import CheckinEntryAutoEntryPending from "../../../components/directivesFormSteps/CheckinEntryFormStep/AutoEntry/CheckinEntryAutoEntryPending";
import { MaintenanceForwardingsCheckinEntryStepOptions } from "../../../types/maintenanceForwardingsShowDirectiveDetails.type";

export const checkinEntryOptions: {
  [K in MaintenanceForwardingsCheckinEntryStepOptions]: {
    title: string;
    description: string | undefined;
    components: {
      pending: React.ComponentType;
      completed: React.ComponentType;
    };
  }
} = {
  [MaintenanceForwardingsCheckinEntryStepOptions.AutoEntry]: {
    title: 'Auto-locomoção',
    description: 'Informe um usuário na sua empresa para transporte do equipamento, se aceito, o usuário será notificado.',
    components: {
      pending: CheckinEntryAutoEntryPending,
      completed: CheckinEntryAutoEntryCompleted,
    },
  },
}
